module.exports = __webpack_public_path__ + "static/media/striped_bar_packShip.4cc6e100.svg";